import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Problems() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto ">
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#2B8FE8" }}>Problem</span>
            </h2>
            <p>
              Being an advocate for change is not an easy task and in their
              early days, Oz’s team was troubled by their website’s low
              conversion rate. Looking for a way to transform their business,
              they turned to Tekrevol, and we welcomed the challenge.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center offset-lg-1 "
          >
            <StaticImage
              src="../../../images/case-studies/oz-leasing/problem_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={960}
              height={653}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Problems;
